import React from "react";
import CTASection from "./CTASection";

const Footer = () => {
  return (
    <footer className="site-footer">
      <CTASection />
    </footer>
  );
};

export default Footer;
